module.exports = __webpack_public_path__ + "static/investigation-logo-f396451788286fb69340c8498152547d.png";